import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import NoResults from 'components/NoResults';
import LinePieChart from 'components/Charts/LinePieChart';
import CategoryGrid from 'components/Dashboard/CategoryGrid';
import { MIN_DESKTOP_WIDTH } from 'constants/misc';

const styles = theme => ({
  title: {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.secondary.text,
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    marginTop: '2rem',
    [`@media screen and (max-width: ${MIN_DESKTOP_WIDTH}px)`]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  circle: {
    width: '190px',
    height: '190px',
    marginRight: '1rem',
    minHeight: '200px',
    margin: '0 auto',
    [`@media screen and (max-width: ${MIN_DESKTOP_WIDTH}px)`]: {
      width: 'auto',
      margin: 'unset',
    },
  },
  table: {
    marginTop: '12px',
    width: '100%',
  },
});

const PieChartCard = (props) => {
  const {
    className,
    classes,
    dataSource,
    title,
    loading,
  } = props;
  const [activeIndex, setActiveIndex] = React.useState(0);
  return (
    <Card className={className}>
      {!loading && dataSource.length ?
        <>
          <div className={classes.title}>{title}</div>
          <div className={classes.wrapper}>
            <div className={classes.circle}>
              <LinePieChart activeIndex={activeIndex} setActiveIndex={setActiveIndex} dataSource={dataSource} />
            </div>
            <div className={classes.table}>
              <CategoryGrid activeIndex={activeIndex} setActiveIndex={setActiveIndex} dataSource={dataSource} />
            </div>
          </div>
        </> :
        <NoResults
          height="18.75rem"
          className="mb-3"
          loading={loading}
          results={dataSource}
        />
      }
    </Card>
  );
};

PieChartCard.propTypes = {
  classes: PropTypes.element.isRequired,
  className: PropTypes.string.isRequired,
  dataSource: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

PieChartCard.defaultProps = {
  loading: false,
};

export default withStyles(styles)(PieChartCard);
